import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.css']
})
export class AlertComponent implements OnInit {
 
  @Input("message")   message = "";
  @Input("type")      type = "success";    //success  info  warning  danger
  @Input("alert")     alert : object;
  @Input("duration")  duration = 5000;

  constructor() {
  }

  // This is for the self closing alert
  private _subject = new Subject<string>();
  _Message: string;

  ngOnInit(): void {
    this.doInit();
  }

  ngOnChanges(changes: SimpleChanges) {
    /* console.log("changesd detected : ", changes);
    // only run when property "data" changed
    if (changes['message']) {
      this.showMessage(this.message);
    }
    if (changes['duration']) {
      this.showMessage(this.message);
    }
    if (changes['type']) {
      this.showMessage(this.message);
    } */
  }

  doInit() {
    this._subject.subscribe(message => (this._Message = message));
    this._subject
      .pipe(debounceTime(this.duration))
      .subscribe(() => (this.close()));
  }

  close() {
    this._Message = null;
  }

  public showMessage(message, type?) {
    this.type = type || this.type;
    this._subject.next(message);
    console.log(message);
  }
}

export interface IAlert {
  id: number;
  type: string;
  message: string;
}
